import { Accordion, AccordionButton } from '@chakra-ui/react'
import styled from '@emotion/styled'

export const Form = styled.form`
    display: flex;
    flex-direction: column;
`

export const AccordionButtonCustom = styled(AccordionButton)`
    padding: 8px 6px 8px 0px;
`

export const AccordionCustom = styled(Accordion)`
    .chakra-collapse {
        width: 100%;
        overflow: unset !important;
    }
`
